module.exports = __webpack_public_path__ + "./images/f1781aa1c6159a46923885b1427c1bc9.webp";